import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";
import type { UpdateTagRequest } from "../../../zodios/apiDefinitions/api/tags";
import { invalidateTagAffectedQueries } from "./invalidateTagAffectedQueries";

interface UpdateTagParams {
  id: number;
  data: UpdateTagRequest;
}

export const useUpdateTagMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["tags"]);
  return useMutation({
    mutationFn: async ({ id, data }: UpdateTagParams) => await apiClient.updateTag(data, { params: { id } }),
    onSuccess: () => {
      successToast({ message: t(($) => $.tags["Tag updated successfully"]) });
      invalidateTagAffectedQueries(queryClient);
    },
    onError: (error) => {
      errorToast({ message: t(($) => $.tags["Failed to update tag"]), error });
    },
  });
};
